module.exports = __webpack_public_path__ + "img/menu.1b8ab57a.svg";